import { Box } from "@mui/material";
import CarruselPostulate from "./components/CarruselPostulate";
import FormularioPostulacion from "./components/FormularioPostulacion";
import IconosInformativos from "./components/IconosInformativos";
import PostulatePillars from "./components/PostulatePillars";
import SeccionExtra from "./components/SeccionExtra";

export default function Postulate() {

  return (
    <Box component="main" sx={{ backgroundColor: "#f8fafc" }}>
      <CarruselPostulate />
      <PostulatePillars />
      <SeccionExtra />
      <IconosInformativos />
      <FormularioPostulacion />
    </Box>
  );
}
